import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import ImageCard, { ImageCardProps } from 'src/app/molecules/ImageCard/ImageCard';
import { ImageCardWrapper } from './ImageCardList.styles';

interface ImageCardListProps {
  imageCards: ImageCardProps[];
  totalColumns?: number;
}

const ImageCardList = ({ imageCards, totalColumns = 3 }: ImageCardListProps): JSX.Element => {
  return (
    <Grid
      gap='spacing-3xl'
      totalColumns={totalColumns}
      totalColumnsLg={2}
      totalColumnsSm={1}
    >
      {imageCards.map((imageCard, index) => (
        <ImageCardWrapper key={index}>
          <ImageCard
            className='image-card-item'
            {...imageCard}
          />
        </ImageCardWrapper>
      ))}
    </Grid>
  );
};

export default ImageCardList;
